import type { RootState } from "../store";

export interface IsAutosaveBlockedOptions {
  // The checklist modal stays "opened" while browsing its list, underneath
  // the item being edited - a checklist save/close should still be able to
  // trigger an autosave even though that outer modal hasn't closed yet.
  ignoreChecklistModalBlock?: boolean;
}

export const selectIsAutosaveBlocked = (
  state: RootState,
  options?: IsAutosaveBlockedOptions,
): boolean => {
  const entry = state.entrySlice;
  const gen = state.generatorSlice;
  const features = state.generatorFeaturesSlice;

  return (
    entry.openedSaveModal ||
    entry.openedRefetchModal ||
    entry.autosaveSuspendCount > 0 ||
    (!options?.ignoreChecklistModalBlock && gen.checkListsModalProps.opened) ||
    gen.stampsModalProps.opened ||
    Boolean(features.ilModalData) ||
    Boolean(features.deisolatedTimeModalData) ||
    Boolean(features.timeInputPopup) ||
    Boolean(features.NMEAModalData?.opened) ||
    Boolean(features.unitConverterModalData)
  );
};
